export default "__VITE_ASSET__04beb94e__"